module.exports = __webpack_public_path__ + "static/media/PAYMENT-SUCCESS.d3ebf6f9.png";